'use client';

import { c as _c } from "react/compiler-runtime";
import { Transition } from '@headlessui/react';
import { usePathname } from 'next/navigation';
import type { ComponentType } from 'react';
import { stripLocalePrefix } from '~/i18n/i18n-config';
import { type PartnerCookie, usePartner } from '~/libs/partners';
import { useJourneyStore } from '~/stores/journeyStore';
import { PartnerBannerCoOpHolidays } from '../PartnerBannerCoOpHolidays';
import { PartnerBannerFirstChoice } from '../PartnerBannerFirstChoice';
import { PartnerBannerTheGuardianHolidays } from '../PartnerBannerTheGuardianHolidays/PartnerBannerTheGuardianHolidays';
const Banners: Record<NonNullable<PartnerCookie>, ComponentType> = {
  'first-choice': PartnerBannerFirstChoice,
  'co-op holidays': PartnerBannerCoOpHolidays,
  'guardian-holidays': PartnerBannerTheGuardianHolidays
};
export function PartnerBanner(t0) {
  const $ = _c(5);
  const {
    forcePartner
  } = t0;
  const partner = usePartner();
  const pathname = stripLocalePrefix(usePathname() || "");
  const allowItineraryEdits = useJourneyStore(_temp);
  const isNonEditableJourney = pathname.startsWith("/journey/") && allowItineraryEdits !== true;
  if (pathname.startsWith("/map")) {
    return null;
  }
  const bannerName = forcePartner ?? partner;
  const BannerComponent = bannerName && bannerName in Banners ? Banners[bannerName] : undefined;
  if (!BannerComponent || isNonEditableJourney) {
    return null;
  }
  const t1 = !forcePartner;
  let t2;
  if ($[0] !== BannerComponent) {
    t2 = () => <div><BannerComponent /></div>;
    $[0] = BannerComponent;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <Transition show={true} appear={t1} enter="transition-[max-height] duration-300 ease-in-out" enterFrom="max-h-0" enterTo="max-h-40">{t2}</Transition>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp(state) {
  return state.journey?.allowItineraryEdits;
}